import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconChevronLeft = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" }, void 0) }, void 0));
const Memo = memo(SvgIconChevronLeft);
export default Memo;
//# sourceMappingURL=IconChevronLeft.js.map